<template>
    <Modal :isModalOpen="opened" @close="closeModalHandler">
      <div slot="body" class="smodal-body d-flex flex-column justify-content-center align-items-center">
        <div>
            <img class="svg_icon" :src="icon" alt="">
        </div>
        <div class="smodal-content text-center flex flex-column justify-content-center align-items-center">
          <span class="smodal-title">
            {{ modalData?. title }}
          </span>
          <div class="smodal-subtitle">
            <span>
                {{ modalData?.subtitle }}
            </span>
          </div>
        </div>
        <div class="smodal-btns d-flex flex-wrap justify-content-center align-items-center">
          <button
            type="button"
            :class="[{ error: modalType === 'failed' }, 'btn_back']"
            @click="closeModalHandler"
          >
            Back to platform
          </button>
          <button
            v-if="modalType === 'success'"
            type="button"
            :class="[{ error: modalType === 'failed' }, 'again_btn']"
            @click="btnClickHandler"
          >
            {{ modalData?.btn_text }}
          </button>
        </div>
      </div>
    </Modal>
</template>

<script>
import Modal from "../../components/shared/Modal/Modal.vue";
export default {
  components: {
    Modal,
  },
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    subModalData: {
      type: Object | null,
      required: true
    }
  },
  data() {
    return {
      successIcon: require('@/assets/img/sub_success.svg'),
      errorIcon: require('@/assets/img/sub_error.svg')
    }
  },
  computed: {
    modalData() {
      return this.subModalData;
    },
    icon() {
      return this.subModalData?.type === 'success' ? this.successIcon : this.errorIcon;
    },
    modalType() {
      return this.subModalData?.type;
    }
  },
  methods: {
    closeModalHandler() {
      this.$emit('cancel');
      this.removeSubscriptionQuery();
    },
    removeSubscriptionQuery() {
      const currentRoute = this.$route;
      const { subscription, ...queryWithoutSubscription } = currentRoute.query;
      this.$router.replace({
        ...currentRoute,
        query: queryWithoutSubscription,
      });
    },
    btnClickHandler() {
      this.$emit('click');
    }
  }
}
</script>

<style scoped>
.smodal-body {
  max-width: 300px;
  gap: 19px;
}

.smodal-content {
  gap: 6px;
  font-family: Inter;
}
.smodal-title {
  font-size: 24px;
  font-weight: 700;
  color: #4F4F4F;
}
.smodal-subtitle {
  color:#828282;
  font-size: 16px;
  max-width: 265px;
}
.smodal-btns {
  gap: 10px;
}
.again_btn {
  border: 1px solid #27AE60;
  background-color: #27AE60 !important;
  color: white !important;
}
.again_btn.error {
  border: 1px solid #3056D3;
  background-color: #3056D3 !important;
}
.again_btn:hover {
  background: white !important;
  color: #27AE60 !important;
}
.again_btn.error:hover {
  color: #3056D3 !important;
}
.btn_back {
  border: 1px solid #27AE60;
  padding: 9px 20px !important;
  font-size: 16px !important;
  color: #27AE60 !important;
}
.btn_back.error {
  border: 1px solid #3056D3;
  background: #3056D3 !important;
  color: #fff !important;
}
.btn_back:hover {
  background: #27AE60 !important;
  color: #fff !important;
}
.btn_back.error:hover {
  color: #3056D3 !important;
  background: white !important;
}
.btn_back,
.again_btn {
  font-family: inherit;
  font-size: 16px;
  line-height: 24px;
  outline: none;
  background: transparent;
  border-radius: 6px;
  padding: 10px;
  cursor: pointer;
  transition: all 150ms linear;

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
}
</style>